/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type EmailArchiveBrowseControllerListEmailsLayoutArchetype =
  (typeof EmailArchiveBrowseControllerListEmailsLayoutArchetype)[keyof typeof EmailArchiveBrowseControllerListEmailsLayoutArchetype];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailArchiveBrowseControllerListEmailsLayoutArchetype = {
  hero_full_bleed: 'hero_full_bleed',
  hero_split: 'hero_split',
  editorial_lede: 'editorial_lede',
  grid_3up: 'grid_3up',
  grid_2up: 'grid_2up',
  single_product: 'single_product',
  lookbook: 'lookbook',
  list_stack: 'list_stack',
  banner_stack: 'banner_stack',
  text_forward: 'text_forward',
  collage: 'collage',
  carousel_strip: 'carousel_strip',
  sequence_steps: 'sequence_steps',
  data_panel: 'data_panel',
  quote_feature: 'quote_feature',
  offer_block: 'offer_block',
  transactional_receipt: 'transactional_receipt',
  other: 'other',
} as const;
